import { render } from "./AppAdminNav.vue?vue&type=template&id=a8899776&scoped=true"
import script from "./AppAdminNav.vue?vue&type=script&lang=js"
export * from "./AppAdminNav.vue?vue&type=script&lang=js"

import "./AppAdminNav.vue?vue&type=style&index=0&id=a8899776&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8899776"]])

export default __exports__